import AppContextProvider from '@providers/AppContextProvider';
import themeStyles from '@styles/themes.module.scss';
import { Locale, ShopBundle } from '@types-internal';

import OverlaysProvider from './OverlaysProvider';

export type ProvidersProps = {
  shopBundle: ShopBundle;
  locale: Locale;
  domain: string;
  csrfToken?: string;
};

const Providers: React.FC<React.PropsWithChildren<ProvidersProps>> = ({
  children,
  shopBundle,
  domain,
  locale,
  csrfToken,
}) => {
  return (
    <div className={themeStyles[shopBundle]}>
      <AppContextProvider value={{ shopBundle, locale, domain, csrfToken }}>
        <OverlaysProvider>{children}</OverlaysProvider>
      </AppContextProvider>
    </div>
  );
};

export default Providers;
